// convert time to a human readable format
// Input '2018-07-24T09:59:42Z'
// Output: 7/24/2018 9:59 AM CDT
export function displayReadableTime(dateTimeString, selectedTimezone = '') {
  if (dateTimeString !== null) {
    var d = new Date(dateTimeString)
    if (selectedTimezone) {
      return d
        .toLocaleString('en-US', {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: true,
          timeZone: selectedTimezone,
          timeZoneName: 'short',
        })
        .replace(/,/, '')
    }
    return d
      .toLocaleString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
        timeZoneName: 'short',
      })
      .replace(/,/, '')
  } else {
    dateTimeString = 'NA'
  }
  return dateTimeString
}
